










import Vue from 'vue';
import VueCompositionAPI, {computed, defineComponent} from '@vue/composition-api';
Vue.use(VueCompositionAPI);

export interface ImageStackProps {
  images: string[];
  size: number;
}

const ImageStack = defineComponent({
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  setup(props: ImageStackProps) {
    const imageSize = computed(() => {
      return `${props.size}px`;
    });

    const first2Imgs = computed(() => {
      return props.images.slice(0, 2).map((img) => `url(${img})`);
    });

    return {
      imageSize,
      first2Imgs,
    };
  },
});

export default ImageStack;
